import React, { useState } from "react";
import Meta from "../../components/Meta";

const About = () => {
  const [video, setVideo] = useState(false);
  
  return (
    <>
      <Meta title="About || mtion.xyz | Create, Play, Remix. Redefine Play with mtion." />
      
      {/* Page Title Section */}
      <section className="relative pt-24 lg:pb-8 ">
        {/* Background Gradient */}
        <picture className="pointer-events-none absolute inset-0 -z-10">
          <img 
            src="/images/gradient_light.jpg" 
            alt="gradient background" 
            className="h-full w-full object-cover dark:hidden" 
          />
          <img 
            src="/images/gradient_dark.jpg" 
            alt="gradient background" 
            className="h-full w-full object-cover hidden dark:block" 
          />
        </picture>
        
        <div className="container mx-auto px-4">
          {/* Content Container */}
          <div className="max-w-2xl mx-auto py-16 text-left">
            <h1 className="font-display text-jacarta-700 mb-6 text-4xl font-semibold dark:text-white transition-transform duration-500 transform hover:scale-105">
              About mtion Interactive
            </h1>
            
            <p className="dark:text-jacarta-300 text-lg leading-relaxed mb-6 transition-opacity duration-300 hover:opacity-90">
              We are a startup based in Canada that is passionate about gaming and social experiences. We believe video games are becoming more than just a "game"—they’re evolving into spaces where creativity and community thrive, bringing people together in new and meaningful ways.
            </p>
            
            <p className="dark:text-jacarta-300 text-lg leading-relaxed mb-6 transition-opacity duration-300 hover:opacity-90">
              At mtion, we are building a new kind of social platform that lets you unleash your creativity through interactive experiences and connect with other gamers in epic ways. Our mission is to unite the world through play. Whether you're crafting your own immersive stories or discovering new adventures with friends, mtion is here to make your creativity come alive.
            </p>
            
            <p className="dark:text-jacarta-300 text-lg leading-relaxed mb-6 transition-opacity duration-300 hover:opacity-90">
              Ready to join the adventure? Say hi! 👉 <a href="mailto:hello@mtion.xyz" className="text-primary underline">hello@mtion.xyz</a>
            </p>
          </div>
        </div>
      </section>
      
      {/* Future Sections (e.g., Team, Partners, News) */}
      {/* <Team />
      <Partners />
      <About_news />
      <Story /> */}
    </>
  );
};

export default About;
